import React, { PureComponent, Fragment } from 'react';
import { arrayOf, object, string } from 'prop-types';
import { connectCurrentRefinements } from 'connectors';
import { Badge } from 'components';

import './BadgeFilters.scss';

class BadgeFilters extends PureComponent {
    static propTypes = {
        items: arrayOf(object).isRequired,
        excludedFilters: arrayOf(string),
    };

    static defaultProps = {
        excludedFilters: [],
    };

    render() {
        const { items, excludedFilters } = this.props;

        const filtersCount = items.filter(
            item =>
                item.currentRefinement !== 'false' &&
                !excludedFilters.includes(item.attribute),
        ).length;

        return (
            <Fragment>
                {filtersCount > 0 && (
                    <Badge content={filtersCount} className="badge-filters" />
                )}
            </Fragment>
        );
    }
}

export default connectCurrentRefinements(BadgeFilters);
